if (!customElements.get('card-v2-variant-selector')) {
  customElements.define('card-v2-variant-selector', class extends HTMLElement {

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.addEventListener('change', this.onVariantChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));

      setTimeout(() => { this.updateCardData(true); }, 50);
    }

    onClick(e) {
      if (e.target.matches('.card-v2-view-all-colors')) {
        e.preventDefault();
        this.querySelectorAll('.hidden-swatch').forEach(el => el.style.display = 'block');
        e.target.style.display = 'none';
      }
    }

    onVariantChange(e) {
      if (!e.target.matches('.card-v2-radio')) return;

      if (e.target.classList.contains('card-v2-radio-color')) {
        const wrapper = e.target.closest('.card-v2-swatches');
        wrapper.querySelectorAll('.card-v2-swatch').forEach(lbl => lbl.style.outline = 'none');
        const label = e.target.closest('label');
        if (label) {
          label.style.outline = '1px solid rgb(var(--color-foreground))';
          label.style.outlineOffset = '2px';
        }
      } else if (e.target.classList.contains('card-v2-radio-pill')) {
        const wrapper = e.target.closest('.card-v2-pills');
        wrapper.querySelectorAll('.card-v2-pill').forEach(lbl => {
          lbl.style.background = 'rgb(var(--color-background))';
          lbl.style.color = 'rgb(var(--color-foreground))';
          lbl.style.borderColor = '#e1e1e1';
        });
        const label = e.target.closest('label');
        if (label) {
          label.style.background = 'rgb(var(--color-foreground))';
          label.style.color = 'rgb(var(--color-background))';
          label.style.borderColor = 'rgb(var(--color-foreground))';
        }
      }

      this.updateCardData(false);
    }

    updateCardData(isInitialLoad = false) {
      const jsonScript = this.querySelector('.card-v2-json');
      if (!jsonScript) return;

      let variants;
      try {
        variants = JSON.parse(jsonScript.textContent);
      } catch(err) {
        console.error("Card V2 JSON parsing error:", err);
        return;
      }

      const checkedRadios = Array.from(this.querySelectorAll('.card-v2-radio:checked'));
      if (checkedRadios.length === 0) return;

      const match = variants.find(v => {
        return checkedRadios.every(radio => {
          const optionIndex = parseInt(radio.dataset.optionIndex);
          return v.options[optionIndex] === radio.value;
        });
      });

      if (match) {
        const card = this.closest('.card-wrapper');
        if(!card) return;

        const idInput = card.querySelector('.card-v2-final-id');
        if (idInput) idInput.value = match.id;

        const links = card.querySelectorAll('.card__media, .card-v2-title');
        links.forEach(link => {
          try {
            const url = new URL(link.href);
            url.searchParams.set('variant', match.id);
            link.href = url.toString();
          } catch(e) {}
        });

        if (!isInitialLoad && match.featured_image) {
          const img = card.querySelector('.card-v2-main-image');
          if (img) {
            img.src = match.featured_image;
            img.srcset = match.featured_image;
          }
          const pictureSources = card.querySelectorAll('picture source');
          pictureSources.forEach(source => {
            source.srcset = match.featured_image;
          });
        }

        const btn = card.querySelector('.card-v2-add-btn');
        if (btn) {
          if (match.available) {
            btn.textContent = window.variantStrings?.addToCart || "Add to cart";
            btn.disabled = false;
            btn.classList.remove('disabled');
          } else {
            btn.textContent = window.variantStrings?.soldOut || "Sold out";
            btn.disabled = true;
            btn.classList.add('disabled');
          }
        }

        const priceRegular = card.querySelector('.price-item--regular');
        if (priceRegular) priceRegular.innerHTML = match.price;
      }
    }
  });
}
